import { graphql, useStaticQuery } from "gatsby";
import BlockText from "../../block-content/block-text";
import NewsPost from "../../news/news-post";

const RelatedNewsBlock = ({ props, section }) => {
  const relatedNewsBlock = props;
  const related = useStaticQuery(graphql`
    {
      news: allSanityNews {
        nodes {
          section {
            urlPrefix
          }
        }
      }
      newsPosts: allSanityNewsPost(sort: { publishedAt: DESC }) {
        nodes {
          _id
          id
          publishedAt
          slug {
            current
          }
          mainImage {
            hotspot {
              y
              x
              width
              height
            }
            crop {
              bottom
              left
              right
              top
            }
            asset {
              _id
            }
            altText
            caption
            attribution
          }
          categories {
            _id
            title
            categorySlug {
              current
            }
          }
          _rawIntro(resolveReferences: { maxDepth: 10 })
          title
          videoID
          externalLink
        }
      }
    }
  `);

  const hasNews = related.news.nodes.some((node, count) => {
    return node.section.urlPrefix === section;
  });

  const postsFiltered = related.newsPosts.nodes.filter((node) => {
    return relatedNewsBlock.criteria.some((criterion) => {
      if (criterion._type === `category`) {
        return node.categories.some((nodeCategory) => {
          return nodeCategory._id === criterion._id;
        });
      }
      return node._id === criterion._id;
    });
  });

  const relatedNewsPosts = relatedNewsBlock.limit
    ? postsFiltered.slice(0, relatedNewsBlock.limit)
    : postsFiltered;

  return (
    <section key={relatedNewsBlock._key} className="py-10 md:py-16">
      <div className="max-w-6xl px-4 mx-auto">
        <div className="flex flex-wrap md:-mx-4">
          {(relatedNewsBlock.title || relatedNewsBlock._rawBody) && (
            <div className="w-full md:w-10/12 md:px-4 mx-auto">
              {relatedNewsBlock.title && (
                <>
                  <hr className="w-8 border-yellow-500 border-4 mb-2" />
                  <h2 className="text-blue-500 font-bold tracking-tighter text-xl md:text-4xl mb-1 md:mb-3 leading-none tracking-tight">
                    {relatedNewsBlock.title}
                  </h2>
                </>
              )}
              <div className="text-sm md:text-lg mb-8 md:mb-16">
                {relatedNewsBlock._rawBody && (
                  <BlockText blocks={relatedNewsBlock._rawBody} />
                )}
              </div>
            </div>
          )}

          {relatedNewsPosts.map((newsPost) => (
            <NewsPost key={newsPost._id} post={newsPost} section={hasNews ? section: '/'} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedNewsBlock;
